interface Props {
  source: 'main' | 'backup' | undefined;
}

/** Discreet MAIN/BACKUP indicator. */
export function SourceIndicator({ source }: Props) {
  if (source === undefined) return null;
  const color = source === 'backup' ? 'text-amber-400' : 'text-neutral-500';
  return (
    <span className={`text-[10px] uppercase tracking-widest ${color}`}>
      Source&nbsp;·&nbsp;{source === 'main' ? 'MAIN' : 'BACKUP'}
    </span>
  );
}
